import { Component, Input } from '@angular/core'
import { ExpertGroupPortal } from 'src/app/shared/interfaces/expert-group-portal.interface'
import { Discussion } from '../../../../../shared/interfaces/discussion.interface'

@Component({
  selector: 'app-discussion-card',
  templateUrl: './discussion-card.component.html',
  styleUrls: ['./discussion-card.component.scss']
})
export class DiscussionCardComponent {
  @Input() discussion: Discussion
  @Input() expertGroupPortal: ExpertGroupPortal
}
